module.exports = __webpack_public_path__ + "community3.03a6d506.png";